export default __webpack_public_path__ + "static/media/icon-store.231efbc9.png";